import React, { Fragment } from "react";

import { DeploymentService } from "Api/organizations/projects/environments/deployments/types";
import ViewPortOnly from "src/organization/pages/project/environment/metrics/components/ViewPortOnly";
import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";
import { getDistanceToPreload } from "src/organization/pages/project/environment/metrics/utils/helper";

import * as S from "./Grid.styles";
import GridService from "./GridService";

type ServiceGroupProps = {
  services: DeploymentService[];
  onBrush: (timeFrame: TimeFrameType) => void;
};

const ServiceGroup = (props: ServiceGroupProps) => {
  const { services, onBrush } = props;

  const index = services?.[0]?.["kind"];
  const section = index == "webapp" ? "Application" : index;

  const { rootMargin } = getDistanceToPreload();

  return services.length > 0 ? (
    <Fragment>
      <S.SectionHeader>{`${section}s`}</S.SectionHeader>
      {services.map(service => {
        return (
          <ViewPortOnly
            id={service.name}
            key={service.name}
            option={{ rootMargin }}
          >
            <GridService onBrush={onBrush} service={service} />
          </ViewPortOnly>
        );
      })}
    </Fragment>
  ) : null;
};

export default ServiceGroup;
